/* eslint-disable object-shorthand */
/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2017, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

(function () {
  // Must change defaultFAItems, and defaultContentItems, as well as "handlesButton" to the appropriate values.
  // This extension is hopefully used in the future for generalized options, but RIGHT NOW, it is used only
  // for fontName and is specified to do so.
  const DropdownButtonExtension = MediumEditor.Extension.extend({ // jshint ignore: line

    name: 'dropdownExtension',

    execOn: 'fontName',
    defaultFAItems: [],
    // These are hopefully used in the future as more generalized options.
    defaultContentItems: ['Arial', 'Etc', 'Item 3'],
    classList: [''],

    constructor: function(options) {
      MediumEditor.Extension.call(this, options); // jshint ignore: line
    },

    init: function() {
      const that = this;

      const formHtml = '<div class="medium-editor-list-container">'
            + '<select class="medium-editor-form-select"></select>'
        + '</div>';

      this.listContainer = $.parseHTML(formHtml);
      const select = $(this.listContainer).find('select');

      // Add in the necessary elements, check through both available fields, by default, use text array.
      if (this.defaultFAItems.length > 0) {
        for (let i = 0; i < this.defaultFAItems.length; i++) {
          const faOption = this.document.createElement('option');
          faOption.innerHTML = this.defaultFAItems[i];
          faOption.value = this.defaultFAItems[i];
          select.append(faOption);
        }
      } else {
        for (let j = 0; j < that.defaultContentItems.length; j++) {
          const option = that.document.createElement('option');
          option.innerHTML = that.defaultContentItems[j].FONT_NAME;
          option.value = that.defaultContentItems[j].FONT;
          select.append(option);
        }
      }

      // Attach editor events to keep status updates.
      this.attachToEditables();

      // Handle the typing inside of the text field.
      this.on(select[0], 'change', this.handleClickedOption.bind(this));

      // This should only be set if the user is on an Android, since that is the only platform that the
      // font families dropdown is broken on, for some reason.
      if (that.browserService.isAndroid()) {
        // This event happens first, and still has the user's selection, save that here.
        this.on(select[0], 'click', (e) => {
          that.userSelection = that.base.exportSelection();
        });

        // Then the blur event happens, because the select we just clicked is about to get canceled!
        // So instead of that happening, we basically overwrite what the blur event is doing.
        this.on(select[0], 'blur', (e) => {
          // We set the toolbar momentarily visible, as the selection is removed on the first click.
          $('.medium-editor-toolbar').css('visibility', 'visible');
          // We then set the selection back to what the user had selected.
          that.base.importSelection(that.userSelection);
          // Then we remove our hard-coded visibility, and allow the toolbar to react to user command/touch
          // as it normally would, resulting in a much better user experience.
          $('.medium-editor-toolbar').css('visibility', '');
        });
      }

      // Get back the DOM element from the jQuery for use in the getButton function below.
      this.listContainer = this.listContainer[0];
    },

    getSelect: function getSelect() {
      return this.getButton().querySelector('select.medium-editor-form-select');
    },

    attachToEditables: function attachToEditables() {
      this.subscribe('positionToolbar', this.handleToolbarPosition.bind(this));
    },

    detachFromEditables: function detachFromEditables() {
      this.unsubscribe('positionToolbar', this.handleToolbarPosition.bind(this));
    },

    handleToolbarPosition: function handleToolbarPosition(event) {
      let attribute = `${this.document.queryCommandValue(this.execOn)}`;
      attribute = attribute.replace(/['"]+/g, '');
      this.updateSelection(attribute);
    },

    updateSelection: function updateSelection(currentSelection) {
      const select = this.getSelect();

      // Find the current font using the object structure in the constant.
      const currentFont = this.defaultContentItems.find((font) => font.FONT === currentSelection);
      if (!currentFont) {
        // If the currentFont is undefined, that means we've selected a video/image etc block, and this
        // extension was initialized and run via the toolbar, even though it isn't being shown. Set the value
        // to the default calluna, serif, even though it isn't going to be shown to avoid errors.
        select.value = 'calluna, serif';
      } else {
        // Set the value of the select to the font family that is currently applied to our selection.
        select.value = currentFont.FONT;
      }
    },

    handleClickedOption: function handleClickedOption(event) {
      const selectedAttribute = this.getSelect().value;
      if (selectedAttribute === '') {
        this.clearSelectedAttribute();
      } else {
        // Find the current font using the object structure in the constant.
        const currentFont = this.defaultContentItems.find((font) => font.FONT === selectedAttribute);

        this.document.execCommand('styleWithCSS', false, true);
        this.execAction('fontName', { name: currentFont.FONT });

        // Check through all of the spans, remove the double quotes for the HTML sanitizer on the backend,
        // and apply the "handled-span" class so the spans aren't removed by our multiple span clean-ups.
        const newSpanTags = $('.bulb-page-content span');
        for (let i = 0; i < newSpanTags.length; i++) {
          const currentTag = $(newSpanTags[i]);
          if (currentTag.css('font-family').replace(/['"]+/g, '') === currentFont.FONT
            && !currentTag.hasClass('handled-span')) {
            currentTag.addClass('handled-span');
          }
        }
      }
    },

    getButton: function getButton() {
      return this.listContainer;
    },

    destroy: function destroy() {
      this.detachFromEditables();
    },
  });

  MediumEditor.extensions.dropdown = DropdownButtonExtension; // jshint ignore: line
}());
